export default "__VITE_ASSET__DBuNZbIH__"